import React from "react";

import { StatusBadge } from "@/shared/components/settings-atoms";
import { STATUS_LABEL, statusOf } from "./listing";
import { kindOf } from "./preview";

import type { KbNode } from "@/shared/types";

/** What a status means, on hover. */
function statusHint(node: KbNode): string {
  const status = statusOf(node);
  if (status === "failed") return node.file?.ingest_error ?? "Couldn't read this file";
  if (status === "processing") return "Writing its summary and notes";
  if (status === "not-indexed") return kindOf(node) === "image" ? "Agents don't read images" : "No text could be read from it";
  return "Agents can read and search it";
}

/** Where a file stands with the agents; nothing for a folder. */
export function FileStatusBadge({ node }: { node: KbNode }) {
  const status = statusOf(node);
  if (!status) return null;
  const tone = status === "indexed" ? "success" : status === "failed" ? "danger" : "neutral";
  return (
    <span title={statusHint(node)} className="inline-flex">
      <StatusBadge tone={tone}>
        {status === "processing" && <span className="w-1.5 h-1.5 rounded-full bg-[var(--info)] motion-safe:animate-pulse" />}
        {STATUS_LABEL[status]}
      </StatusBadge>
    </span>
  );
}
